import { fork, all } from "redux-saga/effects";

import { watchDismissableAlerts } from "kit/alert";

import sharedSaga from "../containers/Shared/Shared.saga";
import appSaga from "../containers/App/App.saga";
import confirmSaga from "../containers/Confirm/Confirm.saga";

import clientLoggerSaga from "./clientLoggerSaga";
import appInitSaga from "./appInitSaga";
import errorHandlerSaga from "./errorHandlerSaga";
import viewTrackerSaga from "./viewTracker.saga";
import clickCounterSaga from "./clickCounter.saga";
import routeChangeSaga from "./routeChangeSaga";

export default function* rootSaga() {
  yield all([
    fork(clientLoggerSaga),
    fork(sharedSaga),
    fork(confirmSaga),
    fork(watchDismissableAlerts),
    fork(errorHandlerSaga),
    fork(appInitSaga),
    fork(appSaga),
    fork(clickCounterSaga),
    fork(viewTrackerSaga)
    // fork(routeChangeSaga)
  ]);
}
